import { Component, OnInit } from '@angular/core';
import { SelectDestinationService } from '@login/services/select-destination.service';
import { NavigationService } from '@login/services/navigation.service';

@Component({
  selector: 'app-select-destination',
  templateUrl: './select-destination.component.html',
  styleUrls: ['./select-destination.component.scss'],
})
export class SelectDestinationComponent implements OnInit {
  programs;

  constructor(
    private selectDestinationService: SelectDestinationService,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    this.selectDestinationService.getSelectDestinationLink().subscribe(
      (res: any) => {
        if (!res.status || res.statusText !== 'Successful') {
          this.navigationService.goToLoginScreen();
          return;
        }

        this.programs = Object.keys(res.result).map(key => ({
          ...res.result[key],
          programName: key,
        }));
      },
      () => this.navigationService.goToLoginScreen(),
    );
  }
}
